import camelcase from 'camelcase';

const logos = require.context('./images/logos', true);

const exportEnv = {
  apiHost: 'https://my.apro.at',
  smorderGraphHost: 'https://smorder-graph.azurewebsites.net',
  clientName: 'waiter',
  imageUrl: 'https://smorder.blob.core.windows.net/images/', // 'https://smorder.blob.core.windows.net/images/',
  smorderEnv: null,
};

Object.keys(process.env).forEach((key) => {
  if (key.indexOf('REACT_APP_') === -1) {
    return;
  }
  const mappedKeyName = camelcase(key.replace('REACT_APP_', ''));
  exportEnv[mappedKeyName] = process.env[key];
});

exportEnv.loginLogo = logos(`./${exportEnv.loginLogo}`).default;


export default exportEnv;
